export class ValidateWaitingListKeyError extends Error {}
export class RatesError extends Error {}
